import { render, staticRenderFns } from "./DealsKpi.vue?vue&type=template&id=424f376c&"
import script from "./DealsKpi.vue?vue&type=script&lang=js&"
export * from "./DealsKpi.vue?vue&type=script&lang=js&"
import style0 from "./DealsKpi.vue?vue&type=style&index=0&id=424f376c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports